module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photo_2@2x-08ff390ca8cc911fe3343c85e5836ddb.jpg";